
import { defineComponent } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';

export default defineComponent({
    name: 'RegularItemQuantity',
    props: {
        quantity: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    setup() {
        const labels = useBlockLabels();
        return {
            labels,
        };
    },
});
